class MobilePhoneValidationErrorController {
}

const MobilePhoneValidationErrorComponentDefinition = {
    controller: MobilePhoneValidationErrorController,
    template: require('./mobile-phone-validation-error.component.html').trim(),
    bindings: {
        headerMessage: '<',
        contentMessage: '<',
        onRequestNewPinCode: '&',
    },
};

module.exports = {
    MobilePhoneValidationErrorController,
    MobilePhoneValidationErrorComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/common/mobilephonevalidator/mobile-phone-validation-error.component.js